import { render, staticRenderFns } from "./RegimenEmailEdit.vue?vue&type=template&id=334396f5"
import script from "./RegimenEmailEdit.vue?vue&type=script&lang=js"
export * from "./RegimenEmailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports